import PropTypes from "prop-types";
import { Form, Radio } from "antd";
import React from "react";
import { connect } from "react-redux";
import { ContentProvider, Types } from '../../../../../CommonComponents/ContentMessages';
import ViewAdditionalInfo from '../../../../NPA/Pages/Step1Setup/Components/ViewAdditionalInfo';
import { handleRadioChangePrimary, handleRadioChangeSecondary } from "../../../actions";
import { DeliveryMarginBottom, DisplayFlexAlign, LabelWrapperDelivery, MailContentWrapper, MailContentWrapperfirst, MainWrapper, RadioButtonWrapper, RadioWrappered, SpanWrap, Underlinelink } from "../styles";
import { RadioButton } from "../../../../../CommonComponents/commonStyles";


class DeliveryMethod extends React.Component {

  state = {
    show: false
  };
  advisorType = this.props.advisorType;
  userType = this.props.userType;
  handleViewInfo = () => {
    document.body.style.overflow = "hidden";
    this.setState({
      show: true
    });
  };
  handleOkay = () => {
    document.body.style.overflow = "";
    this.setState({
      show: false
    });
  };
  handleRadioChange = (e, type, advisorType) => {
    if (advisorType === "Primary") {
      this.props.handleRadioChangePrimary({
        [type]: e.target.value
      });
    } else {
      this.props.handleRadioChangeSecondary({
        [type]: e.target.value
      });
    }
  };
  render() {
    const isDisabled = !(
      (this.advisorType === "Primary" && this.userType === "primary") ||
      (this.advisorType === "Secondary" && this.userType === "secondary") ||
      (this.advisorType === "Secondary" && this.props.isNewSecondaryAdd === true)
    );
    return (
      <ContentProvider types={[Types.GET_MODAL_CONTENT]} pages={["Delivery Method"]}>
        <MainWrapper>
          {this.state.show ? <ViewAdditionalInfo handleOkay={this.handleOkay} /> : null}
          <RadioWrappered>
            <Form.Item
              label={
                <DeliveryMarginBottom>
                  <LabelWrapperDelivery>Preferred Delivery Method</LabelWrapperDelivery>
                </DeliveryMarginBottom>
              }
            >
              <RadioButtonWrapper
                onChange={e => this.handleRadioChange(e, "deliveryMethod", this.advisorType)}
                value={
                  this.advisorType === "Primary"
                    ? this.props.radioInfoPrimary
                      ? this.props.radioInfoPrimary.deliveryMethod
                      : "E-Delivery"
                    : Object.keys(this.props.radioInfoSecondary).length !== 0
                    ? this.props.radioInfoSecondary && this.props.radioInfoSecondary.deliveryMethod !== ""
                      ? this.props.radioInfoSecondary.deliveryMethod
                      : "E-Delivery"
                    : "E-Delivery"
                }
              >
                <MailContentWrapper>
                  <DisplayFlexAlign>
                    <RadioButton id={this.props.advisorType + "rdElectronicDelivery"} disabled={isDisabled} value="E-Delivery">
                      Electronic delivery (suggested)
                    </RadioButton>
                    <Underlinelink onClick={this.handleViewInfo} id={this.props.advisorType +"anrElectronicDeliveryPopup"}>
                      View additional information
                    </Underlinelink>
                  </DisplayFlexAlign>
                </MailContentWrapper>
                <MailContentWrapperfirst>
                  <RadioButton id={this.props.advisorType + "rdPaperDelivery"} disabled={isDisabled} value="Paper">
                    Paper delivery (U.S. mail)
                  </RadioButton>
                </MailContentWrapperfirst>
                <MailContentWrapperfirst>
                  <RadioButton
                    id={this.props.advisorType + "rdPaperDeliveryWithEmail"}
                    disabled={isDisabled}
                    value="Paper Delivery With Electronic Notification"
                  >
                    <SpanWrap>U.S. mail with email notification</SpanWrap>
                  </RadioButton>
                </MailContentWrapperfirst>
              </RadioButtonWrapper>
            </Form.Item>
          </RadioWrappered>
        </MainWrapper>
      </ContentProvider>
    );
  }
}


 DeliveryMethod.propTypes = {
  advisorType: PropTypes.string,
  handleRadioChangePrimary: PropTypes.func,
  handleRadioChangeSecondary: PropTypes.func,
  isNewSecondaryAdd: PropTypes.bool,
  radioInfoPrimary: PropTypes.shape({
    confirmSSN: PropTypes.string,
    deliveryMethod: PropTypes.string,
    dob: PropTypes.string,
    firstname: PropTypes.string,
    gender: PropTypes.string,
    lastname: PropTypes.string,
    middlename: PropTypes.any,
    ssn: PropTypes.string,
    suffix: PropTypes.string,
    title: PropTypes.string
  }),
  radioInfoSecondary: PropTypes.shape({
    confirmSSN: PropTypes.string,
    deliveryMethod: PropTypes.string,
    dob: PropTypes.string,
    firstname: PropTypes.string,
    gender: PropTypes.string,
    key: PropTypes.number,
    lastname: PropTypes.string,
    middlename: PropTypes.any,
    ssn: PropTypes.string,
    suffix: PropTypes.string,
    title: PropTypes.string
  }),
  userType: PropTypes.string
};

const mapStateToProps = state => ({
  primaryInfo: state.getIn(["myAccountInfo", "primaryAdvisor", "info"]),
  secondaryInfo: state.getIn(["myAccountInfo", "secondaryAdvisor", "info"])
});

const mapDispatchToProps = dispatch => {
  return {
    handleRadioChangePrimary: arr => dispatch(handleRadioChangePrimary(arr)),
    handleRadioChangeSecondary: arr => dispatch(handleRadioChangeSecondary(arr))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeliveryMethod);
